// extracted by mini-css-extract-plugin
export default {"points-balance-skeleton":"styles_points-balance-skeleton__l9Qcr","shimmer":"styles_shimmer__3cDu+"};